
import { GetAppSettingsResponse } from '@/api/dtos';
import AppSettingsContext from '@/contexts/AppSettingsContext';
import useAppSettings from '@/hooks/useAppSettings';
import { FC, PropsWithChildren } from 'react';


export interface IAppSettingsProviderProps {
    initial?: GetAppSettingsResponse;
}

export const AppSettingsProvider: FC<PropsWithChildren<IAppSettingsProviderProps>> = ({ initial, children }) => {
    const appSettings = useAppSettings({ revalidateOnFocus: false, fallbackData: initial});

    return (
        <AppSettingsContext.Provider value={appSettings}>
            {children}
        </AppSettingsContext.Provider>
    );
}

export default AppSettingsProvider;
